<template>
  <div>
    <my-header></my-header>

    <div class="page">
      <b-breadcrumb>
        <b-breadcrumb-item :to="{name:'rushes'}">Ражи</b-breadcrumb-item>
        <b-breadcrumb-item :to="{name:'rush_info'}">Раж {{rushId}}</b-breadcrumb-item>
        <b-breadcrumb-item :to="{name:'rush_race'}">Заезд {{raceId}}</b-breadcrumb-item>
      </b-breadcrumb>

      <h2>Игрок {{playerId}} (участник заезда)</h2>

      <div class="section-container">
        <side-nav
          :menuItems="menuItems"
          class="side-nav"
        />

        <div class="content-box">
          <router-view></router-view>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import MyHeader from './Header.vue';
import SideNav from './SideNav.vue';

export default {
  name: 'RushRacePlayer',

  components: {
    MyHeader,
    SideNav,
  },

  props: {
    rushRaceId: {
      type: Object,
      required: true
    },

    playerId: {
      type: Number,
      required: true,
    },
  },

  computed: {
    /** @returns {number} */
    rushId() {
      return this.rushRaceId.rushId;
    },

    /** @returns {number} */
    raceId() {
      return this.rushRaceId.raceId;
    },

    menuItems() {
      return [
        {
          title: 'Информация',
          route: {name: 'rush_race_player_info'},
        },
        {
          title: 'История очков',
          route: {name: 'rush_race_player_score_history'},
        },
      ];
    },
  },
};
</script>

<style scoped>
.page {
  margin-left: 1rem;
  max-width: 600px;
}

.section-container {
  display: flex;
  align-items: flex-start;
}

.side-nav {
  margin-right: 2rem;
  background-color: rgb(242, 247, 251);
}

.content-box {
  width: 600px;
}
</style>
